import React from 'react';
import { Box, Typography } from '@mui/material';

const BannerSection: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: {
          xs: 200,  // Reduced from 300
          sm: 250,  // Reduced from 380
          md: 300,  // Reduced from 500
          lg: 350,  // Reduced from 600
          xl: 400   // Reduced from 650
        },
        // Ultra-wide screens
        '@media (min-width: 1920px)': {
          height: 450  // Reduced from 700
        },
        // Small mobile
        '@media (max-width: 480px)': {
          height: 180  // Reduced from 250
        },
        // Very small mobile
        '@media (max-width: 380px)': {
          height: 160  // Reduced from 220
        },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src="https://images.unsplash.com/photo-1560707303-4e980ce876ad?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80"
        alt="Agriculture Banner"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'brightness(0.6)',
        }}
      />
      
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: {
            xs: '20px',
            sm: '40px',
            md: '60px',
            lg: '80px',
            xl: '80px'
          },
          transform: 'translateY(-50%)',
          textAlign: 'left',
          zIndex: 2,
          paddingLeft: {
            xs: '0px',
            sm: '20px',
            md: '80px',
            lg: '150px',
            xl: '200px'
          },
          paddingRight: {
            xs: '20px',
            sm: '40px',
            md: '60px'
          },
          maxWidth: {
            xs: '100%',
            sm: '100%',
            md: '90%',
            lg: '85%',
            xl: '80%'
          },
          // Ultra-wide screens - combined left and paddingLeft
          '@media (min-width: 1920px)': {
            left: '100px',
            paddingLeft: '250px'
          }
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '1.5rem',    // Reduced from 2rem
              sm: '1.8rem',    // Reduced from 2.8rem
              md: '2.2rem',    // Reduced from 3.8rem
              lg: '2.8rem',    // Reduced from 4.8rem
              xl: '3.2rem'     // Reduced from 5.5rem
            },
            // Ultra-wide screens
            '@media (min-width: 1920px)': {
              fontSize: '3.5rem'  // Reduced from 6.5rem
            },
            // Large screens
            '@media (min-width: 1536px) and (max-width: 1920px)': {
              fontSize: '3.3rem'  // Reduced from 6rem
            },
            // Small mobile
            '@media (max-width: 480px)': {
              fontSize: '1.3rem'  // Reduced from 1.6rem
            },
            // Very small mobile
            '@media (max-width: 380px)': {
              fontSize: '1.2rem'  // Reduced from 1.4rem
            },
            fontFamily: '"Lora", serif',
            fontWeight: 700,
            lineHeight: {
              xs: 1.2,
              sm: 1.15,
              md: 1.1
            },
            color: '#FFFFFF',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            marginBottom: {
              xs: '6px',      // Reduced from 8px
              sm: '8px',      // Reduced from 12px
              md: '10px',     // Reduced from 14px
              lg: '12px'      // Reduced from 16px
            },
            whiteSpace: {
              xs: 'normal',
              md: 'nowrap'
            }
          }}
        >
          Lo natural al alcance de todos
        </Typography>
        <Typography
          sx={{
            fontSize: {
              xs: '1.5rem',    // Reduced from 2rem
              sm: '1.8rem',    // Reduced from 2.8rem
              md: '2.2rem',    // Reduced from 3.8rem
              lg: '2.8rem',    // Reduced from 4.8rem
              xl: '3.2rem'     // Reduced from 5.5rem
            },
            // Ultra-wide screens
            '@media (min-width: 1920px)': {
              fontSize: '3.5rem'  // Reduced from 6.5rem
            },
            // Large screens
            '@media (min-width: 1536px) and (max-width: 1920px)': {
              fontSize: '3.3rem'  // Reduced from 6rem
            },
            // Small mobile
            '@media (max-width: 480px)': {
              fontSize: '1.3rem'  // Reduced from 1.6rem
            },
            // Very small mobile
            '@media (max-width: 380px)': {
              fontSize: '1.2rem'  // Reduced from 1.4rem
            },
            fontFamily: '"Lora", serif',
            fontWeight: 700,
            lineHeight: {
              xs: 1.2,
              sm: 1.15,
              md: 1.1
            },
            color: '#FFFFFF',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            whiteSpace: {
              xs: 'normal',
              sm: 'normal',
              lg: 'nowrap'
            }
          }}
        >
          Sembrando hoy la salud del mañana
        </Typography>
      </Box>
    </Box>
  );
};

export default BannerSection;